export default __webpack_public_path__ + "static/media/transfacil_galery_2.d0e3d662.jpg";